<template>
  <main class="page-shell">
    <section class="section">
      <div class="container">
        <article class="surface notfound-card">
          <p class="eyebrow">404</p>
          <h1>Page Not Found</h1>
          <p>The page you requested is unavailable.</p>
          <router-link to="/" class="back-link">Return to Portfolio</router-link>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "Notfound"
};
</script>

<style scoped>
.notfound-card {
  max-width: 560px;
  padding: 2rem;
}

.eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
}

h1 {
  margin: 0.5rem 0;
  font-family: var(--font-display);
}

p {
  margin: 0;
  color: var(--text-secondary);
}

.back-link {
  margin-top: 1rem;
  display: inline-block;
  text-decoration: none;
  color: var(--accent);
}
</style>
